import React from "react";

import { IConfimationViewProps } from "../../../interfaces/modals";

export const ConfirmationView = (props: IConfimationViewProps) => {
    const { title, content, onClose, cancelFn, cancelTxt, action, actionTxt } = props;

    const onCancel = () => {
        if (cancelFn) cancelFn();
        onClose();
    };

    return (
        <div className="immersion_admin__message_modal__confirmation_view">
            <br />
            <h4 className="color_dark">{title}</h4>
            <p className="color_dark_grey">{content}</p>
            <br />
            <div className="immersion_admin__message_modal__confirmation_actions">
                <button className="immersion_admin__btn immersion_admin__btn__secondary" onClick={onCancel}>{cancelTxt}</button>
                <button
                    className='immersion_admin__btn immersion_admin__btn__primary'
                    onClick={action}
                >
                    {actionTxt}
                </button>
            </div>
        </div>
    );
};